import React from "react";
import styled from "styled-components";
import { display, height, width } from "styled-system";

const StyledSvg = styled.svg`
  ${display}
  ${height}
  ${width}
`;

const StyledPath = styled.path`
  fill: ${({ fill, theme }) => theme.colors[fill] || fill};
  fill-opacity: ${({ fillOpacity }) => fillOpacity};
`;

const Chevron = ({
  fill = "#424242",
  fillOpacity = "0.65",
  height = "16",
  viewBox = "0 0 9 16",
  width = "9",
  ...props
}) => (
  <StyledSvg height={height} viewBox={viewBox} width={width} {...props}>
    <StyledPath
      fill={fill}
      fillOpacity={fillOpacity}
      d={
        "M2 4.66936L2.99937 3.66998L7.33 8.00061L2.99937 12.3312L2 11.3319L5.33125 8.00061L2 4.66936Z"
      }
    />
  </StyledSvg>
);

export default Chevron;
